import { createContext } from 'react';

interface MobileMenuContextValue {
  pdfFile?: File | null;
  isTopSectionExpanded: boolean;
  onToggleTopSection: () => void;
}

export const MobileMenuContext = createContext<MobileMenuContextValue | undefined>(undefined);
